<template>
  <div>
    <div id="overlay" :class="{ show: loadingState }">
      <div class="center-screen">
        <span id="loader"></span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      loadingState: "getLoading",
    }),
  },
};
</script>

<style>
body.overlay-open {
  overflow: hidden;
}

#overlay {
  position: fixed;
  background-color: black;
  opacity: 0.5;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  display: none;
}

#overlay.show {
  display: block;
}

#loader {
  height: 60px;
  width: 60px;
  color: rgba(90, 90, 90, 0.2);
  position: relative;
  display: inline-block;
  border: 5px solid;
  border-radius: 50%;
  border-right-color: #5a5a5a;
  animation: rotation 1s linear infinite;
}

.center-screen {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: 100vh;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
